var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M7.99999 0.0598204C6.44594 0.241456 4.97165 0.846538 3.73807 1.80901C2.50449 2.77148 1.55903 4.05436 1.0049 5.51758C0.450774 6.9808 0.30928 8.56814 0.595864 10.1063C0.882448 11.6445 1.5861 13.0743 2.62999 14.2398L6.99999 19.0898C7.25309 19.3689 7.56178 19.5919 7.90623 19.7445C8.25067 19.8971 8.62325 19.976 8.99999 19.976C9.37674 19.976 9.74931 19.8971 10.0938 19.7445C10.4382 19.5919 10.7469 19.3689 11 19.0898L15.35 14.2398C16.5008 12.9468 17.2321 11.335 17.4471 9.61745C17.6621 7.8999 17.3508 6.15754 16.5542 4.62076C15.7576 3.08398 14.5134 1.82517 12.986 1.01079C11.4585 0.196399 9.71992 -0.135206 7.99999 0.0598204ZM8.99999 11.7498C8.36469 11.7518 7.74309 11.5652 7.2139 11.2137C6.6847 10.8622 6.27171 10.3616 6.02722 9.77518C5.78273 9.18881 5.71773 8.54307 5.84046 7.91973C5.96318 7.2964 6.26812 6.72349 6.71664 6.27357C7.16517 5.82364 7.73711 5.51692 8.36006 5.39225C8.98302 5.26758 9.62895 5.33056 10.2161 5.57322C10.8032 5.81588 11.3051 6.22731 11.6583 6.7554C12.0115 7.2835 12.2 7.90452 12.2 8.53982C12.2 9.38944 11.8632 10.2044 11.2633 10.8061C10.6635 11.4078 9.8496 11.7472 8.99999 11.7498Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 11.8396C10.8667 11.8396 12.38 10.3263 12.38 8.45959C12.38 6.59287 10.8667 5.07959 9 5.07959C7.13327 5.07959 5.62 6.59287 5.62 8.45959C5.62 10.3263 7.13327 11.8396 9 11.8396Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.30fa87d2b2081a865474ba8e2a9f371e.svg";
export { ForwardRef as ReactComponent };